import React from 'react';
import { Link } from 'react-router-dom';
import { FaForumbee, FaWrench, FaTrophy, FaAnchor, FaMap, FaQuestionCircle } from 'react-icons/fa';

// Map icon string to actual React Icon
const getIcon = (iconName) => {
  switch (iconName) {
    case 'forum': return <FaForumbee size={32} />;
    case 'wrench': return <FaWrench size={32} />;
    case 'trophy': return <FaTrophy size={32} />;
    case 'anchor': return <FaAnchor size={32} />;
    case 'map': return <FaMap size={32} />;
    default: return <FaQuestionCircle size={32} />;
  }
};

export default function CategoryCard({ category }) {
  return (
    <Link to={`/community/c/${category.slug}`} className="text-decoration-none">
      <div className="community-card clickable h-100 d-flex flex-column text-center align-items-center">
        <div className="mb-3" style={{ color: '#ddb467' }}>
          {getIcon(category.icon)}
        </div>
        <h4 className="mb-2 text-white">{category.name}</h4>
        <p className="text-muted small mb-3 flex-grow-1">
          {category.description}
        </p>
        <div className="d-flex w-100 justify-content-between border-top border-dark pt-2 small text-muted">
          <span>{category.threadCount || 0} Threads</span>
        </div>
      </div>
    </Link>
  );
}
